import { A_Error } from "@adaas/a-concept";


export class AreInterpreterError extends A_Error {

}